var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1000px","height":"500px","background-color":"#2E60AF"},on:{"contextmenu":_vm.handleContextMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }